import React from 'react';
import { ChevronLeft, ChevronRight, Loader2 } from 'lucide-react';

const WEEKDAYS = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
const MONTHS = [
  'January', 'February', 'March', 'April', 'May', 'June',
  'July', 'August', 'September', 'October', 'November', 'December',
];

const pad = (n) => String(n).padStart(2, '0');
const dateKey = (y, m, d) => `${y}-${pad(m + 1)}-${pad(d)}`;

// Month grid matching the GHL booking widget: greyed/disabled for unavailable
// dates, blue chip for available, filled dark circle for the selected date, and
// a small dot under today.
const CalendarPicker = ({ viewMonth, setViewMonth, availableDates, selectedDate, onSelectDate, loading }) => {
  const { year, month } = viewMonth;
  const firstDay = new Date(year, month, 1).getDay(); // 0=Sun
  const daysInMonth = new Date(year, month + 1, 0).getDate();

  const today = new Date();
  const todayKey = dateKey(today.getFullYear(), today.getMonth(), today.getDate());

  const prevMonth = () => {
    const m = month - 1;
    setViewMonth(m < 0 ? { year: year - 1, month: 11 } : { year, month: m });
  };
  const nextMonth = () => {
    const m = month + 1;
    setViewMonth(m > 11 ? { year: year + 1, month: 0 } : { year, month: m });
  };

  // Build cells: leading blanks + the month's days.
  const cells = [];
  for (let i = 0; i < firstDay; i += 1) cells.push(null);
  for (let d = 1; d <= daysInMonth; d += 1) cells.push(d);

  return (
    <div className="preob-cal__picker">
      <div className="preob-cal__nav">
        <button type="button" className="preob-cal__nav-btn" onClick={prevMonth} aria-label="Previous month">
          <ChevronLeft size={20} />
        </button>
        <span className="preob-cal__nav-label">
          {MONTHS[month]} {year}
          {loading && <Loader2 size={14} className="preob-spin preob-cal__nav-spin" />}
        </span>
        <button type="button" className="preob-cal__nav-btn preob-cal__nav-btn--next" onClick={nextMonth} aria-label="Next month">
          <ChevronRight size={20} />
        </button>
      </div>

      <div className="preob-cal__weekdays">
        {WEEKDAYS.map((w) => (
          <span key={w} className="preob-cal__weekday">{w}</span>
        ))}
      </div>

      <div className="preob-cal__grid">
        {cells.map((d, i) => {
          if (d === null) return <span key={`b${i}`} className="preob-cal__cell preob-cal__cell--empty" />;
          const key = dateKey(year, month, d);
          const isAvailable = availableDates.has(key);
          const isSelected = key === selectedDate;
          const isToday = key === todayKey;
          const cls = [
            'preob-cal__cell',
            isAvailable ? 'preob-cal__cell--available' : 'preob-cal__cell--disabled',
            isSelected ? 'preob-cal__cell--selected' : '',
          ].filter(Boolean).join(' ');
          return (
            <button
              key={key}
              type="button"
              className={cls}
              disabled={!isAvailable}
              onClick={() => isAvailable && onSelectDate(key)}
              aria-pressed={isSelected}
            >
              {d}
              {isToday && <span className="preob-cal__today-dot" />}
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default CalendarPicker;
